import store from "@/store/index";

/** 与全站语言开关一致：fanyi=true 为中文，false 为意大利语 */
export function getFaqLang(fanyi) {
  const isZh =
    typeof fanyi === "boolean" ? fanyi : store.state.fanyi;
  return isZh ? "zh" : "it";
}

export function resolveFaqPage(page, fanyi) {
  if (!page) {
    return {
      pageName: "",
      title: "",
      answer: "",
      content: "",
      menu: "",
      menuKey: "",
      router: "",
      menuLevel: 1,
    };
  }

  const lang = getFaqLang(fanyi);
  const locale = page[lang] || page.it || page.zh || {};

  return {
    ...page,
    pageName: locale.pageName || "",
    title: locale.title || "",
    answer: locale.answer || "",
    content: locale.content || "",
    menu: locale.menu || "",
  };
}

export function resolveFaqPages(pages, fanyi) {
  return (pages || []).map((page) => resolveFaqPage(page, fanyi));
}

export function getFaqLabel(labels, key, fanyi) {
  if (!labels) return "";
  const lang = getFaqLang(fanyi);
  return (labels[lang] && labels[lang][key]) || "";
}

function stripHtml(html) {
  if (!html) return "";
  return String(html)
    .replace(/<[^>]*>/g, " ")
    .replace(/&nbsp;/gi, " ")
    .replace(/&amp;/gi, "&")
    .replace(/&lt;/gi, "<")
    .replace(/&gt;/gi, ">")
    .replace(/&quot;/gi, '"')
    .replace(/&#39;/gi, "'")
    .replace(/\s+/g, " ")
    .trim();
}

/** 统一大小写、重音、标点，便于中意双语模糊匹配 */
function normalizeForSearch(text) {
  return stripHtml(text)
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[''`´]/g, "'")
    .replace(/[？?！!。，,、；;：:（）()「」【】\[\]""«»\-–—]/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

function buildHomeLinkLabelMap(pages) {
  const home = (pages || []).find((page) => page.router === "centro-de-ayuda");
  const map = {};
  if (!home || !home.homeBlockLinks) return map;

  Object.values(home.homeBlockLinks).forEach((block) => {
    (block.links || []).forEach((link) => {
      if (!link.router) return;
      if (!map[link.router]) map[link.router] = [];
      if (link.zh) map[link.router].push(link.zh);
      if (link.it) map[link.router].push(link.it);
    });
  });

  return map;
}

function getSearchableText(page, homeLinkLabels) {
  const zh = page.zh || {};
  const it = page.it || {};
  const extraLabels = homeLinkLabels[page.router] || [];
  const parts = [
    zh.pageName,
    zh.title,
    zh.answer,
    zh.content,
    zh.menu,
    it.pageName,
    it.title,
    it.answer,
    it.content,
    it.menu,
    page.seoTitle,
    page.seoDescription,
    ...extraLabels,
  ];
  return normalizeForSearch(parts.filter(Boolean).join(" "));
}

function pageMatchesKeyword(page, normalizedQuery, tokens, homeLinkLabels) {
  const haystack = getSearchableText(page, homeLinkLabels);
  if (!haystack) return false;
  if (haystack.includes(normalizedQuery)) return true;
  return tokens.every((token) => haystack.includes(token));
}

export function searchFaqPages(pages, keyword) {
  const raw = (keyword || "").trim();
  if (!raw) return [];

  const normalizedQuery = normalizeForSearch(raw);
  if (!normalizedQuery) return [];

  const tokens = normalizedQuery.split(" ").filter(Boolean);
  const homeLinkLabels = buildHomeLinkLabelMap(pages);

  return pages.filter((page) => {
    if (page.menuLevel !== 3) return false;
    return pageMatchesKeyword(page, normalizedQuery, tokens, homeLinkLabels);
  });
}
